import React from "react";
import Link from "next/link";
import { NextSeo } from "next-seo";
import DiscordCta from "../components/DiscordCta";
import { useT } from "@jammable/ui-core/src/i18n";

const NotFoundPage = () => {
  const t = useT();
  return (
    <div className="tw-bg-white tw-px-4 tw-pb-16 tw-pt-2 tw-text-jam-ink md:tw-px-8 md:tw-pt-4">
      <NextSeo title={t("nav.404.seoTitle")} noindex={true} />
      <main className="tw-mx-auto tw-flex tw-w-full tw-max-w-[900px] tw-flex-col tw-items-center tw-gap-4 tw-rounded-[34px] tw-bg-jam-lav tw-px-5 tw-py-12 tw-text-center md:tw-rounded-[44px] md:tw-px-12 md:tw-py-16">
        <div className="jam-display tw-text-[96px] tw-font-extrabold tw-leading-none tw-tracking-[-0.05em] tw-text-jam-purple md:tw-text-[160px]">
          404
        </div>
        <h1 className="jam-display tw-m-0 tw-text-[32px] tw-font-extrabold tw-leading-none md:tw-text-[48px]">
          {t("nav.404.title")}
        </h1>
        <p className="tw-m-0 tw-max-w-lg tw-text-[15px] tw-font-semibold tw-text-jam-muted md:tw-text-lg">
          {t("nav.404.body")}
        </p>
        <div className="tw-mt-2 tw-flex tw-flex-wrap tw-justify-center tw-gap-2.5">
          <Link
            href="/"
            className="tw-rounded-full tw-bg-jam-lime tw-px-7 tw-py-4 tw-text-[15px] tw-font-extrabold tw-text-jam-ink tw-no-underline"
          >
            {t("nav.404.home")}
          </Link>
          <Link
            href="/models"
            className="tw-rounded-full tw-bg-white tw-px-7 tw-py-4 tw-text-[15px] tw-font-extrabold tw-text-jam-ink tw-no-underline hover:tw-text-jam-purple"
          >
            {t("nav.404.browse")}
          </Link>
        </div>
        <div className="tw-mt-6 tw-flex tw-justify-center">
          <DiscordCta variant="banner" label={t("nav.404.discordLabel")}>
            {t("nav.404.discordBody")}
          </DiscordCta>
        </div>
      </main>
    </div>
  );
};

export default NotFoundPage;
